import MfcLens from '../libraries/mfc/MfcLens'

/**
 * SSR-safe accessor for the MfcLens tracking singleton.
 *
 * MfcLens references `window` internally, so it must never be instantiated
 * outside the browser. Call sites use optional chaining:
 *
 * `getLens()?.Signup_Click()`
 */
export function getLens() {
    if (typeof window === 'undefined') return null
    return MfcLens.getInstance(() => window.umami)
}

/**
 * Track Signup_Submit or LoginButton_Click (custom event)
 * to track Login and Signup button interactions
 * @param signup
 * @param provider
 */
export function trackLoginInteraction(signup: boolean, provider?: string) {
    getLens().track(`${signup ? 'Signup_Submit' : 'Login_Click'}`, {
        ...(provider ? { sso: provider } : {}),
    })
}
